/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

export default [
    {
        path: '/?_f=agendaEvent&action=:action&id=:id',
        name: 'agenda.event.action',
    },
]